/**
 * Delegated "Add to Cart" handler for bd-product-card. A single listener
 * on document, so it works regardless of which section renders the card
 * and for cards added later (e.g. via infinite scroll).
 */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.bd-product-grid__atc[data-atc]');
  if (!btn || btn.disabled) return;

  const id = btn.dataset.atc;
  btn.disabled = true;
  btn.textContent = 'Adding…';
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    });
    if (!res.ok) throw new Error();
    const item = await res.json();
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: item,
        sourceId: btn.closest('[id]')?.id,
        data: { variantId: String(id) }
      }
    }));
    btn.textContent = 'Added!';
    setTimeout(() => { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 1500);
  } catch {
    btn.textContent = 'Add to Cart';
    btn.disabled = false;
  }
});
